import React, {useState} from "react";

import { Button } from 'react-bootstrap';
import styled from "styled-components";

import FranchiseVendorsAutoComplete from "../../utils/AutoComplete/FranchiseVendorsAutoComplete";

const SelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  .select {
    width: 300px;
  }
`;

type Props = {
  initialId?:string;
  onSave: (id:string | undefined)=>void;
}

const ParentVendorSelector = (props:Props) => {
  const [parentVendorId, setParentVendorId] = useState<string | undefined>();

  const handleParentVendorSelected = (id: string | undefined) => {
    setParentVendorId(id);
  }

  const handleSaveParentVendorId = async () => props.onSave(parentVendorId);

  return <SelectorContainer>
    <FranchiseVendorsAutoComplete clearable={true} initialId={props.initialId} onSelect={handleParentVendorSelected} className={'select'}/>
    <Button type='button' className='btn btn-primary' bsStyle='primary' onClick={handleSaveParentVendorId}>
      Save
    </Button>
  </SelectorContainer>
};

export default ParentVendorSelector;